import React from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { darken } from "@mui/material/styles";

const CustomizedIconButton = styled(
  React.forwardRef((props, ref) => <IconButton {...props} ref={ref} />),
  { shouldForwardProp: (prop) => prop !== "bgcolor" }
)(({ theme, bgcolor }) => ({
  ...theme.typography.button,
  color: theme.palette.text.secondary,
  boxShadow: theme.shadows[2],
  borderRadius: theme.shape.borderRadius,
  backgroundColor: bgcolor,
  transition: theme.transitions.create(
    ["background-color", "box-shadow", "border"],
    {
      duration: theme.transitions.duration.short,
    }
  ),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: darken(bgcolor, theme.palette.action.hoverOpacity),
  },
}));

export const FilledIconButton = React.forwardRef(function FilledIconButton(
  props,
  ref
) {
  //  Spread the props to the underlying DOM element.
  return (
    <CustomizedIconButton {...props} ref={ref}>
      {props.icon}
    </CustomizedIconButton>
  );
});
